<template>
  <vs-card>
    <vs-table hoverFlat stripe :data="addons" search pagination max-items="10">
      <template slot="header">
        <h3>
          Extrák
        </h3>
        <vs-button radius color="success" type="gradient" icon="add" @click="addAddon()"></vs-button>
      </template>
      <template slot="thead">
        <vs-th>
          Megnevezés
        </vs-th>
        <vs-th>
          Ár
        </vs-th>
        <vs-th>
          Leírás
        </vs-th>
        <vs-th>
        </vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :key="index" v-for="(tr, index) in data">
          <vs-td>
            {{ tr.AddonName }}
          </vs-td>
          <vs-td>
            {{ tr.AddonPrice }}
          </vs-td>
          <vs-td>
            {{ tr.AddonDescription }}
          </vs-td>
          <vs-td>
            <vs-row vs-type="flex" vs-align="right" vs-justify="flex-end">
              <vs-button radius color="warning" size="small" type="gradient" icon="build"
                         @click="editAddon(tr.Id)"></vs-button>
              <vs-button radius color="danger" size="small" type="gradient" icon="clear"
                         @click="delAddon(tr.Id)"></vs-button>
            </vs-row>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>

    <div class="centerx">
      <vs-popup classContent="addAddonModal" title="Új extra hozzáadása" :active.sync="addModal"
                @closemodal="closeModal()">
        <new_addon v-bind:selected="selectedAddon"></new_addon>
      </vs-popup>
    </div>

    <div class="centerx">
      <vs-popup classContent="editAddonModal" title="Extra módosítása" :active.sync="editModal"
                @closemodal="closeModal()">
        <edit_addon v-bind:selected="selectedAddon"></edit_addon>
      </vs-popup>
    </div>
  </vs-card>
</template>

<script>
import {axiosInstance} from "@/main";
import new_addon from "../../components/modals/new_addon";
import edit_addon from "../../components/modals/edit_addon";

export default {
  name: "addons",
  data() {
    return {
      addons: [],
      editModal: false,
      addModal: false,
      selectedAddon: {
        Id: '',
        AddonName: '',
        AddonDescription: '',
        AddonPrice: 0
      }
    }
  },
  components: {
    new_addon, edit_addon
  },
  methods: {
    closeModal() {
      this.editModal = false;
      this.addModal = false;
      this.getAddons();
    },
    getAddons() {
      let self = this;
      axiosInstance
          .get('admin/addonController.php', {withCredentials: true})
          .then((response) => {
            this.addons = response.data.responseData;
          })
          .catch((err) => {
            if (err.response.status === 401)
              self.$root.exterminatus(err.response.data.message);
            else {
              self.$vs.notify({
                title: 'Rendszerüzenet',
                position: 'top-right',
                text: err.response.data.message,
                color: 'danger',
                icon: 'error'
              });
            }
          });
    },
    addAddon() {
      this.selectedAddon.AddonName = '';
      this.selectedAddon.AddonDescription = '';
      this.selectedAddon.AddonPrice = '';
      this.addModal = true;
    },
    editAddon(id) {
      this.selectedAddon = {...this.addons.find(elem => elem.Id === id)};
      this.editModal = true;
    },
    delAddon(id) {
      let self = this;
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Megerősítés`,
        text: 'Valóban törölni kívánja az extrát?',
        acceptText: 'Igen',
        cancelText: 'Nem',
        accept: function () {
          axiosInstance
              .delete('admin/addonController.php?id=' + id, {
                withCredentials: true,
              })
              .then((resp) => {
                self.getAddons();
                self.$vs.notify({
                  title: 'Rendszerüzenet',
                  position: 'top-right',
                  text: resp.data.status === 'OK' ? 'Sikeres törlés.' : 'Sikertelen törlés. ' + resp.data.message,
                  color: resp.data.status === 'OK' ? 'success' : 'danger',
                  icon: resp.data.status === 'OK' ? 'check_box' : 'error'
                });
              })
              .catch((err) => {
                if (err.response.status === 401)
                  self.$root.exterminatus(err.response.data.message);
                else {
                  self.$vs.notify({
                    title: 'Rendszerüzenet',
                    position: 'top-right',
                    text: err.response.data.message,
                    color: 'danger',
                    icon: 'error'
                  });
                }
              });
        }
      });
    }
  },
  created() {
    this.getAddons();
  }
}
</script>

<style scoped>
h3 {
  padding: 15px;
}

.vs-input {
  margin-top: 15px;
  margin-bottom: 15px;
  width: 100%;
}

form {
  width: 100%;
}

.vs-icon {
  margin-left: 15px;
}

.vs-button {
  margin: 1px 5px;
}

</style>